import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./loggedout.html";
import { IS_DEVELOPMENT, LOGOUT_REDIRECT_URL } from '~/config';
import { WireI18n } from '~/modules/stores/i18nStore';
import { publisherStore } from '~/modules/stores/publisher/publisherStore';
import { userStore } from '~/modules/stores/userStore';
import { images } from '~/modules/utilities/assetUtilities';
class LoggedOutPage extends LightningElement {
  constructor(...args) {
    super(...args);
    this.appName = void 0;
    this.labels = void 0;
    this.sharedLabels = void 0;
    this.images = images;
  }
  i18nConnectedCallback(i18n) {
    this.labels = i18n.loggedOutPage;
    this.sharedLabels = i18n.shared;
    this.appName = i18n.globalHeader.appName;
  }
  connectedCallback() {
    // Reset stores with session data in case user navigates back to main page (refer to RootContainer component to identify which stores have session data)
    userStore.reset();
    publisherStore.reset();
    if (IS_DEVELOPMENT && !LOGOUT_REDIRECT_URL) {
      throw new Error('Missing LOGOUT_REDIRECT_URL environment variable');
    }
    window.location.assign(LOGOUT_REDIRECT_URL);
  }
  handleContinue() {
    window.location.assign(LOGOUT_REDIRECT_URL);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(LoggedOutPage, {
  wire: {
    i18nConnectedCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["appName", "labels", "sharedLabels", "images"]
});
const __lwc_component_class_internal = _registerComponent(LoggedOutPage, {
  tmpl: _tmpl,
  sel: "pages-loggedout",
  apiVersion: 62
});
export default __lwc_component_class_internal;